// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1bcffa0a","977":"e0de6c80"}[chunkId] + ".chunk.js";
};